import DefaultLayout from "../components/layout/DefaultLayout";
import { useSelector, useDispatch } from "react-redux";
import { useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { userActions } from "../store/userSlice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isValidLessee } from "../actions/users";

function ValidateLessee() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const recaptcha = useRef();
  const idNumber = useSelector((state) => state.user.register.nationalIdNumber);
  const contractNumber = useSelector(
    (state) => state.user.register.contractNumber
  );
  const isLoading = useSelector((state) => state.user.register.loading);
  const redirectTo = useSelector((state) => state.user.redirectTo);
  const onIdNumber = (event) => {
    dispatch(userActions.setRegisterNationalIdNumber(event.target.value));
  };
  const onContractNumber = (event) => {
    dispatch(userActions.setRegisterContractNumber(event.target.value));
  };

  const onRecaptcha = () => {};
  const continueHandler = () => {
    dispatch(isValidLessee(idNumber, contractNumber));
  };

  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo);
    }
  }, [redirectTo]);

  const body = () => {
    return (
      <div>
        <section className="slice sct-color-1">
          <div className="container relative">
            <div className="row">
              <div className="col-12">
                <div className="py-5 text-center">
                  <h1 className="heading heading-1 strong-400 text-normal">
                    Validemos tu informacion?
                  </h1>

                  <span className="clearfix"></span>

                  <div className="fluid-paragraph fluid-paragraph-sm strong-300 text-center mt-1">
                    CC y numero de contrato.
                  </div>
                  <div>
                    <Form>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInputEmail"
                      >
                        <Form.Label>Numero de Documento</Form.Label>
                        <Form.Control
                          type="string"
                          placeholder=""
                          onChange={onIdNumber}
                          defaultValue={idNumber}
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInputName"
                      >
                        <Form.Label>Numero de contrato</Form.Label>
                        <Form.Control
                          type="string"
                          placeholder=""
                          onChange={onContractNumber}
                          defaultValue={contractNumber}
                        />
                      </Form.Group>
                      {/*<ReCAPTCHA
                        onChange={onRecaptcha}
                        sitekey={process.env.REACT_APP_SITE_KEY}
                      />*/}
                      <Button
                        disabled={!idNumber || !contractNumber}
                        onClick={continueHandler}
                      >
                        Continuar
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default ValidateLessee;
